import { render, staticRenderFns } from "./TechnicalSpecifications.vue?vue&type=template&id=35e12ae1&"
import script from "./TechnicalSpecifications.vue?vue&type=script&lang=js&"
export * from "./TechnicalSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports